// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_er-6";
export var emphasizeQuantity = "_er-3";
export var flatBottomCorners = "_er-5";
export var productImage = "_er-0";
export var quantityContainer = "_er-2";
export var tooltip = "_er-1";
export var wrapAndEllipsesOverflow = "_er-4";